import { ColumnOrMetricName, getDataColForMetadata } from '@blisspointmedia/bpm-types/dist/Columns';
import { App2Channels } from '@blisspointmedia/bpm-types/dist/ScpChannels';
import { GlossaryItem } from '@Components/GlossaryModal/GlossaryModal';

export const GLOSSARY_MAP: Partial<Record<ColumnOrMetricName, GlossaryItem>> = {
  revenue: {
    term: 'KPI Revenue',
    definition:
      'The number of dollars generated in return. Typically commerce uses 14d attribution for attributing revenue to an ad.'
  },
  clicksConversionRate: {
    term: 'Clicks Conversion Rate',
    definition: 'Conversion Rate = KPI volume / clicks'
  },
  impsConversionRate: {
    term: 'Impressions Conversion Rate',
    definition: 'Conversion Rate = KPI volume / impressions'
  },
  roas: {
    term: 'ROAS',
    definition: 'Return on Ad Spend = revenue / spend'
  },
  spend: {
    term: 'Spend',
    definition: 'The number of dollars invested.'
  },
  impressions: {
    term: 'Impressions',
    definition: 'The number of times the ad(s) are delivered.'
  },
  clicks: {
    term: 'Clicks',
    definition: 'The number of times the ad is clicked.'
  },
  cpm: {
    term: 'CPM',
    definition: 'Cost per thousand impressions = (spend x 1,000) / impressions'
  },
  cpc: {
    term: 'CPC',
    definition: 'Cost per Click = spend / clicks'
  },
  ctr: {
    term: 'Clicks and Click-through rate (CTR)',
    definition: `Clicks and Click-through rate (CTR): Clicks, which occur when the viewer clicks an interactive element of your ad, and CTR (Clicks / Impressions) for Video campaigns shouldn’t typically be considered a priority compared to impressions or views (if your goal is awareness) or conversions (if your goal is sales). Low clicks and CTR, is fairly normal in Video campaigns, compared to Search campaigns.
    Clicks and CTR within Video campaigns are typically not metrics that you should have as a priority to determine campaign success. It can be an indicator of how well your ad prompts users to take action upon viewing your ads, but the primary metric with which conversions are given attribution to your Video campaigns is "views" (for example, a click is not required for your campaign to get credit for a conversion, but a view is).`
  },
  viewthroughRate: {
    term: 'Viewthrough rate (VTR)',
    definition: `The viewthrough rate helps you determine the percent of impressions that resulted in a view. It attests to how compelling your ad is. Viewthrough rate helps you answer the question- “Of the people who were prompted with your ad, what percentage were counted as a view?” A low view rate might suggest that the initial portion of your creative wasn’t compelling enough. 20% is considered average across all industries, but it can vary significantly. Also known as view rate. Not all YouTube media will have a view such as non-skippable formats. This includes Bumpers, and since they are a forced view, only impressions will be counted.
  Viewthough rate = views / impressions`
  },
  cpv: {
    term: 'Cost per view (CPV)',
    definition: `This helps you determine on average how much you're paying for a view, and the cost effectiveness of your ads based on views as a main goal of your campaign. CPV is most valuable when it’s used as a means for comparison between ads, ad groups, and campaigns (isolated metrics are not as insightful). You can then determine which strategies are working best based on your budget.
  Average cost per view = cost / views`
  },
  viewsConversionRate: {
    term: 'Views Conversions Rate',
    definition: '(conversions x 1,000) / video views'
  },
  streamingRespIndex: {
    term: 'Streaming Resp. Index',
    definition: `Response Index = (responding impressions / total responding impressions) / (residential impressions / total residential impressions).
  A value above 1 means the row delivers a larger share of responding impressions than of residential impressions.`
  }
  // TODO These haven't been added as column / metrics yet
  // orders: {
  //   term: "Orders",
  //   definition:
  //     "The number of unique orders contributed to the ad on the platform it is served on. In general, we default to using 14 day attribution across the board but it is possible for some to have custom setups.",
  // },
  // units: {
  //   term: "Units",
  //   definition:
  //     "The number of units purchased in the orders contributed to the ad. This should always be equal to or greater than the number of orders.",
  // },
  // acos: {
  //   term: "ACOS",
  //   definition:
  //     "Advertising Cost of Sales. This is the inverse of ROAS and aims to show how much you need to spend in order to generate one dollar of revenue. Formula is spend/revenue. Anything under 1 means that you are generating more revenue than you are spending.",
  // },
  // ntbOrders:{
  //   term: "NTB Orders",
  //   definition:
  //     "New to Brand Orders. The amount of orders that were attributed to your ad where the consumer has not purchased from that brand within the past year.",
  // },
  // ntbSales: {
  //   term: "NTB Sales",
  //   definition:
  //     "New to Brand Sales. The amount of sales revenue generated by the New to Brand Orders.",
  // },
  // conversions: {
  //   term: "Conversions",
  //   definition:
  //     "In Video campaigns, conversions are measured when a viewer is counted as a view for your ad and then takes an action that you’ve defined as valuable to your business, such as an online purchase or a call to your business from a mobile phone.",
  // },
  // cvr: {
  //   term: "Conversions Rate",
  //   definition: `Conversion rate (CVR): CVR gives insight into how effective your ad is at getting users to your site and converting after being counted as a view. Like many of the other metrics, a good CVR is very dependent on the advertiser industry.
  // CVR = Conversions / Views`,
  // },
};

export const getChannelGlossary = (channel: App2Channels): GlossaryItem[] => {
  const glossary: GlossaryItem[] = [];
  getDataColForMetadata(channel).forEach(col => {
    if (GLOSSARY_MAP[col.name]) {
      glossary.push(GLOSSARY_MAP[col.name]);
    }
  });
  return glossary.sort((a, b) => a.term.localeCompare(b.term));
};
